/**
 * Компонент-обертка, который автоматически перерендеривается
 * при смене языка, используя key={language} для "сброса" React-дерева.
 * Используется для повторного выполнения useEffect и повторного запроса
 * данных, зависящих от языка, без необходимости явно следить за языком в каждом компоненте.
 *
 * @component
 * @param {Object} props - Свойства компонента
 * @param {React.ReactNode} props.children - Дочерние элементы, которые нужно отобразить
 * @returns {React.ReactElement}
 *
 * @example
 * const language = useSelector(state => state.language);
 * return (
 *   <LanguageRefresher key={language}>
 *     <MyPage />
 *   </LanguageRefresher>
 * );
 */
const LanguageRefresher = ({ children }) => {
  return <>{children}</>;
};

export default LanguageRefresher;
